import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { toast } from "sonner";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }
    
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/ResetPassword`,
      });
      
      if (error) {
        throw error;
      }
      
      setSubmitted(true);
      toast.success("Check your email for a reset link");
    } catch (err) {
      toast.error(err?.message || "Failed to send reset email");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0b0b0b] px-4">
        <Card className="w-full max-w-md bg-[#121212] text-[#e0e0e0] border border-[#1f1f1f]">
          <CardHeader>
            <CardTitle className="text-center text-2xl">Check Your Email</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-center text-[#a0a0a0]">
              If an account exists for <strong>{email}</strong>, we've sent a password reset link.
            </p>
            <p className="text-center text-sm text-[#808080]">
              The link will expire in 1 hour. Check your spam folder if you don't see it.
            </p>
            <Button
              type="button"
              variant="outline"
              className="w-full mt-4"
              onClick={() => navigate("/Auth")}
            >
              Back to Sign In
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b0b] px-4">
      <Card className="w-full max-w-md bg-[#121212] text-[#e0e0e0] border border-[#1f1f1f]">
        <CardHeader>
          <CardTitle className="text-center text-2xl">Forgot Password</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#a0a0a0] mb-4 text-center">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="text-sm text-[#a0a0a0]">Email</label>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                placeholder="you@example.com"
                className="bg-[#0f0f0f] border-[#1f1f1f] text-[#e0e0e0]"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? "Sending..." : "Send Reset Link"}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-full"
              onClick={() => navigate("/Auth")}
            >
              Back to Sign In
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

export default ForgotPassword;
